import * as React from "react";
import StoreGroupFinderContainer from "../../../../components/StoreGroupFinder/components/StoreGroupFinder/StoreGroupFinderContainer.js";
import { StoreFinderProvider } from "../../../../context/StoreFinder/context/StoreFinder/provider.js";
const StoreGroupRoot = ({
  groupName,
  hideEmail,
  hidePhone,
  stores,
  storeSearchFilters,
  urls
}) => {
  return /* @__PURE__ */ React.createElement(
    StoreFinderProvider,
    {
      googleMapsId: "google-maps-container",
      withUrlParams: true,
      hidePhone,
      hideEmail,
      initialStores: stores ?? void 0,
      urls
    },
    /* @__PURE__ */ React.createElement("style", { jsx: true, global: true }, `
        .banner,
        .notification-bar {
          position: relative;
          z-index: 100;
        }
      `),
    /* @__PURE__ */ React.createElement(
      StoreGroupFinderContainer,
      {
        groupName,
        storeSearchFilters,
        urls
      }
    )
  );
};
export {
  StoreGroupRoot as default
};
//# sourceMappingURL=StoreGroupRoot.js.map
